import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsNominalCodes from './SettingsNominalCodes';

function NominalCodesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Nominal Codes"
        subtitle="Chart of accounts"
        backTo="/settings/finance-setup"
        backLabel="Finance Setup"
        sticky
      />
      <main className="max-w-7xl mx-auto px-6 py-8">
        <SettingsNominalCodes />
      </main>
    </div>
  );
}

export default NominalCodesPage;
